"use strict";
exports.__esModule = true;
exports.findHeaderBanner = void 0;
var types_1 = require("./types");
var findHeaderBanner = function (promotions) {
    var headerBanner = promotions.find(function (promotion) { return promotion.promotionType === types_1.PromotionTypes.HeaderBanner; });
    return headerBanner !== null && headerBanner !== void 0 ? headerBanner : null;
};
exports.findHeaderBanner = findHeaderBanner;
